<template>
  <section>
    <h3 class="h-title">选择供应链服务</h3>  
    <el-form class="e-form f-b" ref="cForm1" :model="cForm1" label-width="120px"  label-position="left" :rules="setpFormRules1">     
      <el-form-item class="w-70" label="单方用章协议" prop="unitSealProtocolFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'unitSealProtocolFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'unitSealProtocolFile')" 
            :on-error="handleError"
            :file-list="cForm1.unitSealProtocolFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      
    </el-form>
    <!-- 按钮 -->					
    <div class="cenrer">	
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>	
      <el-button class="s-but" type="orange" @click.native="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </section>
</template>
<script>
import baseUrl from '@/api/baseUrl.js'
export default {
    name: "step1",
    props: ["active", "id"],
		data() {
			return { 
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token")
        },    
        cForm1: {
          unitSealProtocolFile: []
        },
				setpFormRules1: {
          unitSealProtocolFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ]
        },
        action: '',
        butLoading: false,       
        account: sessionStorage.account
			}
    },
    watch: {
      active(newVal) {
        if(newVal == 1) {
          this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
          // this.action = `http://172.30.15.232:9097/common/uploadFile`;
          this.cForm1 = JSON.parse(sessionStorage.setpForm);
          this.cForm1.unitSealProtocolFile = JSON.parse(this.cForm1.unitSealProtocolFile) || [];
        } 
      }
    },
    mounted(){
      this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
      if(this.id) {
        this.getDetial();
      }
    },
    methods: {
      //获取详情
      getDetial() {
          this.$api.api.contractDetail(this.id).then(res => {
              if(res.code==200){
                  this.cForm1 = Object.assign({}, res.data); 	
                  this.cForm1.unitSealProtocolFile = JSON.parse(this.cForm1.unitSealProtocolFile) || [];
              }else {
                  this.$message.error(res.msg);
              }    
          });      
      },
      cSubmitForm(type) { 
        // 文件必填校验
        this.$refs['cForm1'].validate((valid) => {
          if ( valid ) {  
            // 用户经理
            this.cForm1.userManager = sessionStorage.applyCustomerName
            this.cForm1.userManagerPhone = sessionStorage.applyCustomerContact
            this.cForm1.userManagerAccount = sessionStorage.applyCustomerAccount
            this.cForm1.submitName = sessionStorage.projectName
            this.cForm1.unitSealProtocolFile = JSON.stringify(this.cForm1.unitSealProtocolFile);
            if(type == '0'){
              this.butLoading = true;
              this.cForm1.status = '0'
              this.$api.api.saveContract(JSON.stringify(this.cForm1)).then(response => {
                this.butLoading = false;
                if(response.code == 200){
                  sessionStorage.removeItem("setpForm")
                  this.$message.success("保存成功");
                  this.$router.go(-1);
                }     
              });
            }else{
              sessionStorage.setpForm = JSON.stringify(this.cForm1);
              this.$emit('next');
            }
                                
          }
        })       
      },
    
      handleError(err, file, fileList){
        this.$message.error(file.name + "文件上传失败");
      },
      beforeUpload(file) { 	
        const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
        
        if(!isLt2M) {
          this.$message.error('上传文件大小不能超过 80MB！');
        }
        return isLt2M
      },
      upload(response, file, list, name){
          if(response.code == 200){
            this.$set(this.cForm1, name, 
              [{
                name: response.name,
                url: response.url
              }]
            )
            this.$refs.cForm1.clearValidate(name)
          }else{
            this.$set(this.cForm1, name,[])
            if(response.msg){
              this.$message.error(response.msg);
            }else {
              this.$message.error(file.name + "文件上传失败");
            }							
          }            
      },
      handleRemove(file, fileList, name) {
        this.$set(this.cForm1, name, [])

      },
    }
	}
</script>